import { render } from "./ForbiddenView.vue?vue&type=template&id=138487fc&scoped=true"
const script = {}

import "./ForbiddenView.vue?vue&type=style&index=0&id=138487fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138487fc"]])

export default __exports__